import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { MailOutline, PhoneOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { formatPhoneNumber } from "../utils/PhoneNumber.utils";
export const ContactInfo = ({ email, phoneNumber, style }) => {
    return (_jsxs("div", { style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            ...style
        }, children: [_jsx(EmailLinkWithIcon, { email: email }), _jsx(PhoneLinkWithIcon, { phoneNumber: phoneNumber })] }));
};
export const EmailLinkWithIcon = ({ email, style, justify = "center" }) => {
    return (_jsxs(Flex, { justify: justify, align: "center", style: { minWidth: 0, width: "100%" }, children: [_jsx(SvgIcon, { component: MailOutline, style: {
                    maxWidth: "15px",
                    marginRight: "0.5rem",
                    color: "var(--mantine-color-gray-6)",
                    flex: "0 0 auto"
                } }), _jsx(EmailLink, { email: email, style: style })] }));
};
export const PhoneLinkWithIcon = ({ phoneNumber, style }) => {
    return (_jsxs(Flex, { justify: "center", align: "center", style: { minWidth: 0, width: "100%" }, children: [_jsx(SvgIcon, { component: PhoneOutlined, style: {
                    maxWidth: "15px",
                    marginRight: "0.5rem",
                    color: "var(--mantine-color-gray-6)",
                    flex: "0 0 auto"
                } }), _jsx(PhoneLink, { phoneNumber: phoneNumber, style: style })] }));
};
export const EmailLink = ({ email, style }) => {
    return (_jsx(Link, { to: `mailto:${email}`, style: {
            ...style,
            fontSize: 12,
            fontWeight: 400,
            color: "var(--mantine-color-gray-6)",
            textDecoration: "none",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
            flex: "1 1 auto",
            display: "block",
            maxWidth: "100%"
        }, title: email, onClick: (event) => {
            event.stopPropagation();
            window.location.href = `mailto:${email}`;
        }, children: email }));
};
export const PhoneLink = ({ phoneNumber, style }) => {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
    return (_jsx(Link, { to: `tel:${formattedPhoneNumber}`, style: {
            ...style,
            fontSize: 12,
            fontWeight: 400,
            color: "var(--mantine-color-gray-6)",
            textDecoration: "none",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
            flex: "1 1 auto",
            display: "block",
            maxWidth: "100%"
        }, title: formattedPhoneNumber, onClick: (event) => {
            event.stopPropagation();
            window.location.href = `tel:${formattedPhoneNumber}`;
        }, children: formattedPhoneNumber }));
};
